const calculateDroppedEntitySize = (designWidth, designHeight, entityWidth, entityHeight) => {
  const ratio = entityWidth / entityHeight;
  let droppedWidth, droppedHeight, droppedScale;

  if (entityWidth >= designWidth) {
    droppedScale = ((designWidth * 100) / entityWidth - 4) / 100;
    droppedWidth = entityWidth * droppedScale;
    droppedHeight = droppedWidth / ratio;
  } else if (entityHeight >= designHeight) {
    droppedScale = ((designHeight * 100) / entityHeight - 4) / 100;
    droppedHeight = entityHeight * droppedScale;
    droppedWidth = droppedHeight * ratio;
  } else if (entityWidth > entityHeight) {
    droppedScale = ((designWidth * 100) / entityWidth - 4) / 100;
    droppedWidth = entityWidth * droppedScale;
    droppedHeight = droppedWidth / ratio;
  } else {
    droppedScale = ((designHeight * 100) / entityHeight - 4) / 100;
    droppedHeight = entityHeight * droppedScale;
    droppedWidth = droppedHeight * ratio;
  }

  return { droppedWidth, droppedHeight, droppedScale };
};

const removeAuthToken = (url = '') =>
  url
    .replace(/([?&])authToken=[^&#]*/g, '$1')
    .replace('?&', '?')
    .replace(/[?&](#|$)/, '$1');

export const normalizeApplicationResourceUrl = (
  resourceUrl = '',
  fileServer = process.env.REACT_APP_FILE_SERVER,
) => {
  if (!resourceUrl || !fileServer) return resourceUrl;

  try {
    const configuredApiUrl = new URL(fileServer, 'http://vibino.local');
    const parsedResourceUrl = new URL(resourceUrl, configuredApiUrl.origin);
    const resourcePath = parsedResourceUrl.pathname;

    if (!/^\/api\/(resources|users)\//i.test(resourcePath)) return resourceUrl;

    const configuredPath = configuredApiUrl.pathname.replace(/\/$/, '');
    const pathAfterApi = resourcePath.replace(/^\/api/i, '');
    const normalizedPath = `${configuredPath}${pathAfterApi}`.replace(/\/{2,}/g, '/');
    return `${configuredApiUrl.origin}${normalizedPath}${parsedResourceUrl.search}${parsedResourceUrl.hash}`;
  } catch (error) {
    return resourceUrl;
  }
};

export const generateImageLink = (imageUrl = '', authToken) => {
  const cleanUrl = normalizeApplicationResourceUrl(removeAuthToken(imageUrl));
  const isExportService =
    typeof window !== 'undefined' && window.location.pathname.startsWith('/exportService/');
  if ((process.env.NODE_ENV !== 'development' && !isExportService) || !authToken) {
    return cleanUrl;
  }

  const separator = cleanUrl.includes('?') ? '&' : '?';
  return `${cleanUrl}${separator}authToken=${encodeURIComponent(authToken)}`;
};

export const getImageExtention = (imageUrl = "") => {

  let imageSplit = imageUrl.split("?")[0];

  if(imageUrl.includes("http")){
    imageSplit = imageSplit.split("/api")[1].split(".")[1]
  }else{
    imageSplit = imageSplit.split(".")[1]
  }

  return imageSplit

}

export { calculateDroppedEntitySize };
